<template>
    <v-container
        fluid
    >
        <v-row
            align="center"
            justify="center"
        >
            <img
                class="elevation-1 rounded-circle"
                height="128"
                width="128"
                src="/logologin.jpeg"
            >
        </v-row>
        <v-row
        no-gutters
            align="center"
            justify="center"
        >
            <v-col
                cols="12"
                sm="8"
                md="4"
            >
                <v-card
                    class="mx-auto my-12"
                    max-width="400"
                >
                    <v-card-title>
                        Login
                    </v-card-title>
                    <v-card-text>
                        <v-form
                            ref="form"
                            v-model="valid"
                            lazy-validation
                        >
                            <v-text-field
                                label="Nombre de usuario"
                                name="Username"
                                type="text"
                                v-model="username"
                                :rules="userRules"
                                v-on:keyup.enter="validate"
                                outlined
                                required
                                dense
                            ></v-text-field>
                            <div class="text-end">
                                <router-link style="text-decoration:none;" to="/recover"><a >¿Olvidaste tu contraseña?</a></router-link>
                            </div>
                            <v-text-field
                                id="password"
                                label="Contraseña"
                                name="password"
                                v-model="password"
                                :rules="passRules"
                                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                :type="show1 ? 'text' : 'password'"
                                @click:append="show1 = !show1"
                                v-on:keyup.enter="validate"
                                outlined
                                dense
                                required
                            ></v-text-field>
                            <v-checkbox
                                style="margin-top: -17px;"
                                v-model="remember"
                                label="Recordar sesión"
                                color="success"
                                
                                hide-details
                            ></v-checkbox>
                        </v-form>
                        <div align="center" style="color:red">
                            {{errorLogin}}
                        </div>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                            width="95%"
                            color="success"
                            class="ma-2"
                            :loading="isLoading"
                            :disabled="isLoading || !valid"
                            @click="validate"
                        >
                            Login
                        </v-btn>
                    </v-card-actions>
                    <v-card-text align="center">
                        ¿Aún no tienes cuenta? <a> Contactanos </a>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row
            align="end"
            justify="center"
        >
            <p class="font-weight-light">
                Copyright © {{currentYear}} — SoundAnalytics 
            </p>
        </v-row>
    </v-container>
</template>

<script>
	import moment from 'moment'

	export default {
		name: 'Login',

		data: () => ({
            remember: true,
            valid: false,
            show1: false,
            userRules: [
                v => !!v || 'Usuario es requerido',
            ],
            passRules: [
                v => !!v || 'Password es requerido',
            ],
            username: "",
            password: ""
		}),
		
		methods: {
            login () {
                const payload = {
                    username: this.username,
                    password: this.password,
                    remember: this.remember
                }

                this.$store.dispatch('login', payload)
            },
            validate () {
                const isValid = this.$refs.form.validate()

                if (!isValid)
                    return
                
                const payload = {
                    username: this.username,
                    password: this.password,
                    remember: this.remember
                }
                
                this.$store.dispatch('login', payload)
            },
		},

		computed: {
            isLoading () {
                return this.$store.getters.loadLogin
            },
            errorLogin () {
                return this.$store.getters.errorLogin
            },
            loggedIn () {
                return this.$store.getters.loggedIn
            },
            currentYear () {
                return moment().format("YYYY")
            }
		},

		watch : {
            loggedIn (val) {
                if (val)
                    this.$router.push('/')
            }
		},

		created () {
			moment.locale('es-us')
            store.dispatch('logout')
		}

	}
</script>